/* Moomo R2 · Shop menu. Desktop: hover (150ms) / click / Enter / Space opens; Esc, mouse-leave (200ms grace) or focus
   leaving the trigger + panel closes. Mobile drawer: Shop is an accordion. */
(() => {
  const OPEN_DELAY = 150;
  const CLOSE_DELAY = 200;

  const initDesktop = (btn) => {
    if (btn.dataset.mmReady) return;
    btn.dataset.mmReady = '1';
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    const li = btn.closest('li');
    let openT = null;
    let closeT = null;
    const isOpen = () => btn.getAttribute('aria-expanded') === 'true';
    const clear = () => { clearTimeout(openT); clearTimeout(closeT); };
    const open = () => {
      clear();
      if (isOpen()) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mm-mega-open');
    };
    const close = (refocus) => {
      clear();
      if (!isOpen()) return;
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mm-mega-open');
      if (refocus) btn.focus();
    };
    const desktop = () => window.matchMedia('(min-width: 990px)').matches;

    btn.addEventListener('click', () => (isOpen() ? close() : open()));

    const enter = () => {
      if (!desktop()) return;
      clearTimeout(closeT);
      if (!isOpen()) openT = setTimeout(open, OPEN_DELAY);
    };
    const leave = () => {
      clearTimeout(openT);
      if (isOpen()) closeT = setTimeout(() => close(), CLOSE_DELAY);
    };
    [li, panel].forEach((el) => {
      el.addEventListener('mouseenter', enter);
      el.addEventListener('mouseleave', leave);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) {
        e.preventDefault();
        close(true);
      }
    });
    // focus leaving both the trigger and the panel closes it
    const focusOut = (e) => {
      const to = e.relatedTarget;
      if (to && (btn.contains(to) || panel.contains(to))) return;
      setTimeout(() => {
        const a = document.activeElement;
        if (!btn.contains(a) && !panel.contains(a)) close();
      }, 0);
    };
    btn.addEventListener('focusout', focusOut);
    panel.addEventListener('focusout', focusOut);
    // Tab from the trigger goes straight into the open panel (it is rendered after the header bar in the DOM)
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && !e.shiftKey && isOpen()) {
        const first = panel.querySelector('a, button');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    panel.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const items = [...panel.querySelectorAll('a, button')];
      if (e.shiftKey && document.activeElement === items[0]) { e.preventDefault(); btn.focus(); }
      if (!e.shiftKey && document.activeElement === items[items.length - 1]) {
        // continue to the next header link after Shop
        const next = li.nextElementSibling && li.nextElementSibling.querySelector('a, summary, button');
        if (next) { e.preventDefault(); close(); next.focus(); }
      }
    });
    document.addEventListener('click', (e) => {
      if (isOpen() && !btn.contains(e.target) && !panel.contains(e.target)) close();
    });
    window.addEventListener('resize', () => { if (!desktop()) close(); });
  };

  const initDrawer = (btn) => {
    if (btn.dataset.mmReady) return;
    btn.dataset.mmReady = '1';
    const body = document.getElementById(btn.getAttribute('aria-controls'));
    if (!body) return;
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      body.hidden = !open;
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-mm-mega-btn]').forEach(initDesktop);
    document.querySelectorAll('[data-mm-dshop-btn]').forEach(initDrawer);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
